import { useContext } from 'react'
import { Context } from '@/providers'

function usePageIdContext() {
  return useContext(Context)
}

export { usePageIdContext }
